/**
 * This is a custom version of prompt list used for indexing and forms.  The main difference from PromptList2 is that it
 * does not extend from DFValidator, and adds additional behavior for things like replacing inputs.
 * The validator implementation is completely model based and supports warnings/overrides.
 */
import PromptListCommon from "common/widgets/PromptList/PromptListCommon";
import CustomValidator from "common/validator/CustomValidator";
import "common/bindings/responsive";

var widget;
widget = kendo.ui.Widget.extend(CustomValidator).extend(PromptListCommon).extend({
    options: {
        name: "CustomPromptList",
        autoBind: true,
        readonly: false,
        enabled: true,
        cacheListValues: false,
        validationField: "name", // field used to map up server validation results, defaults to name
        showReadonlyLabel: true,
        responsive: false,
        accessibleText: false,

        // whether the enter key acts like the tab key for moving focus or not
        enterMovesFocus: false,

        // will apply the disabled state of prompts to the readonly value
        disabledWhenReadonly: false
    },

    init: function(element, options) {
        kendo.ui.Widget.fn.init.apply(this, arguments);

        // configure the options to set up validateOnBlur for the prompts
        if (!options) {
            options = {};
        }
        options.validateOnBlur = true;
        options.useDatasourcePlaceholders = true;

        this.wrapper = this.element;
        // call onInit on PromptListCommon
        this.onInit(options);
        this.toggleResponsive(this.options.responsive);
    },

    toggleResponsive: function(responsive) {
        this.element.toggleClass("responsiveFormDesign", !!responsive);
    },

    _updateEmptyInputInfo() {
        this.promptWidgets.forEach((promptInput) => {
            promptInput.setEmptyInfo(this.options.emptyInputInfo);
        });
    },

    setOptions: function(options) {
        kendo.ui.Widget.fn.setOptions.apply(this, arguments);
        options.hasOwnProperty("emptyInputInfo") && this._updateEmptyInputInfo();
        this.toggleResponsive(this.options.responsive);
    },

    destroy: function() {
        kendo.ui.Widget.fn.destroy.call(this);

        this.dependencies.dataSource.unbind("datasourceExecuted");

        // call onDestroy on PromptListCommon
        this.onDestroy();
    },

    validate: function() {
        var me = this;
        var args = arguments;
        return me.dependencies.getFinished()
            .then(function() {
                return CustomValidator.validate.apply(me, args);
            });
    },

    setDataSource: function(ds) {
        // our custom validator needs to know about the current set of prompts first.
        this.setValidatorPrompts(ds);

        this.onSetDataSource(ds);
    },

    onInputChanged: function(e) {
        // run validation for just this input
        this.validateInput(e.sender.options.model);
    },

    setNonPromptFields: function(fields) {
        this.dependencies.nonPromptFields = fields;
    },

    // override to set styles on render of the entire prompt container - these styles should apply to all form controls within the container
    setPromptStyles: $.noop

});
export default widget;
